import { RootState } from '../../store';

export const getAllManualVerificationSessions = (state: RootState) =>
  state.manualVerificationSessionDetails.manualVerificationSessions;
export const getManualVerificationSessionLoadingStatus = (state: RootState) =>
  state.manualVerificationSessionDetails.isFetching;
export const getManualVerificationSessionProviderName = (state: RootState) =>
  state.manualVerificationSessionDetails.providerName;
export const getSelectedManualVerificationSessionData = (state: RootState) =>
  state.manualVerificationSessionDetails.selectedManualVerificationSessionData;
export const getSelectRequestScreenSearchQuery = (state: RootState) =>
  state.manualVerificationSessionDetails.selectRequestScreenSearchQuery;
export const getSelectRequestScreenClickedParameterName = (state: RootState) =>
  state.manualVerificationSessionDetails.selectRequestScreenClickedParameterName;
